const ReceivableWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const Tab = () => import('@/pages/WaterElectricity/tab');
const Progress = () => import('@/pages/WaterElectricity/progress');
const Detail = () => import('@/pages/WaterElectricity/detail');
const Control = () => import('@/pages/WaterElectricity/control');
const GuideMeter = () => import('@/pages/tuition/TuiConventionGuideMeter');
const Add = () => import('@/pages/tuition/TuiConventionAdd');

export default [{
	path: '/WaterElectricityHomePage',
	name: 'WaterElectricityHomePage',
	component: ReceivableWrapper,
}, {
	path: '/WaterElectricityTab',
	component: Tab,
	children: [{
		path: '/',
		component: Detail,
		name: 'WaterElectricityDetails',
	}, {
		path: 'WaterElectricityProgress',
		component: Progress,
		name: 'WaterElectricityProgress',
	}, {
		path: 'WaterElectricityControl',
		component: Control,
		name: 'WaterElectricityControl',
	}],
}, {
	path: '/WaterElectricityGuideMeter',
	component: GuideMeter,
}, {
	path: '/WaterElectricityAdd',
	component: Add,
}];
